<template>
  <v-menu
    offset-y
    v-model="showMenu"
    close-on-click
    nudge-bottom="5"
  >
    <template v-slot:activator="{ on }">
      <component
        :is="!disableDirectLink ? 'router-link' : 'placeholder-component'"
        v-on="on"
        :to="objectLink"
        :target="openInNewTab ? '_blank' : '_self'"
        class="booking-id"
        :title="getLinkTitle(bookingId)"
        @contextmenu.native.prevent.stop="openMenu"
      >
        {{ bookingId }}
        <v-icon
          v-if="canOpenInStayin"
          class="more-icon"
          style="opacity: 0;"
          size="16"
          @click.prevent.stop="openInStayin"
          color="primary"
          :title="trans('general.openInStayin')"
        >mdi-open-in-new</v-icon>
      </component>
    </template>
    <open-in-stayin-menu @open-in-stayin="openInStayin" />
  </v-menu>
</template>

<script>
import ConfigReader from '@/lib/config-reader';
import {MainUtils} from '@/utils/main-utils';
import {LocaleUtils} from '@/utils/locale-utils';
import {OpenInStayinUtils} from '@/utils/open-in-stayin-utils';
import OpenInStayinMenu from '@/components/OpenInStayinMenu';
import PlaceholderComponent from '@/components/PlaceholderComponent';

export default {
  name: 'BookingId',
  components: {
    OpenInStayinMenu,
    PlaceholderComponent
  },
  mixins: [
    MainUtils,
    LocaleUtils,
    OpenInStayinUtils
  ],
  props: {
    value: {
      required: true
    },
    openInNewTab: {
      default () {
        return true;
      }
    },
    customLink: {
      type: Object,
      default: null
    },
    disableDirectLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isObjectProvided() {
      return this.value != null && typeof this.value === 'object';
    },
    bookingId() {
      return this.isObjectProvided ? this.value.id : this.value;
    },
    objectLink() {
      if(this.bookingId == null) {
        return null;
      }

      if (this.customLink) {
        return this.customLink;
      }

      return {
        name: 'BookingDetails',
        params: {
          bookingId: this.bookingId
        }
      }
    }
  },
  methods: {
    openInStayin () {
      const stayinUrlBookingDetails = ConfigReader.value('stayinUrlBookingDetails');
      if (!stayinUrlBookingDetails) {
        return;
      }
      window.open(stayinUrlBookingDetails.replace('{bookingId}', this.bookingId), '_blank');
    }
  }
}
</script>

<style scoped>
.booking-id {
  display: inline-block;
}

.booking-id:hover .more-icon {
  opacity: 1 !important;
}
</style>
